import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmbeddedVideoComponent } from './embedded-video.component'

@NgModule({
    imports: [ CommonModule ],
    declarations: [EmbeddedVideoComponent],
    exports: [EmbeddedVideoComponent],
    providers: []
})
export class EmbeddedVideoModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/embedded-video/embedded-video.module.ts